
const hsbmDialog = {
  state: {
    hsbmState: false,
    hsbmId: '',
    hsbmName: '',
  },

  mutations: {
    SET_HSBMSTATE: (state, val) => {
      state.hsbmState = val
    },
    SET_HSBMID: (state, val) => {
      state.hsbmId = val
    },
    SET_HSBMNAME: (state, val) => {
      state.hsbmName = val
    }
  },
  actions: {}
}
export default hsbmDialog
